$(document).ready(function () {
    // Hide quantity input and disable add to cart button on "montering" (assembly) page
    if (window.location.pathname.indexOf("/18031-montering") !== -1) {
        /** @type {HTMLInputElement} */
        const input = document.querySelector("div.product-add-to-cart>.product-quantity-input");
        input.style.display = "none";
        /** @type {HTMLButtonElement} */
        const button = document.querySelector("div.product-add-to-cart>button.add-to-cart");
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.classList.toggle("disabled", true);
        button.innerText = "Montering hanteras i kassan";
    }


});

// document.addEventListener("DOMContentLoaded", function () {
//     console.log("DOMContentLoaded");
//     // const targetDate = new Date('2025-05-09T06:00:00');
//     const currentDate = new Date();
//     if (currentDate > targetDate) {
//         setLogo();
//     }
// })

// function setLogo() {
//     let country = null;
//     let alt = null;
//     if (window.location.hostname.indexOf("dpj.se") !== -1) {
//         country = "SE";
//         alt = 'DPJ 30 år';
//     } else if (window.location.hostname.indexOf("dpj-workspace.com") !== -1) {
//         const path = window.location.pathname.split("/");
//         if (path.length < 1) {
//             return;
//         }
//         switch (path[1]) {
//             case "fi":
//                 country = "FI";
//                 alt = 'DPJ 30 vuotta';
//                 break;
//             case "de":
//             case "at":
//                 country = "DE";
//                 alt = 'DPJ 30 Jahre';
//                 break;
//             case "nl":
//                 country = "NL";
//                 alt = 'DPJ 30 jaar';
//                 break;
//             case "dk":
//                 country = "DK";
//                 alt = 'DPJ 30 år';
//                 break;
//             case "fr":
//                 country = "FR";
//                 alt = 'DPJ 30 ans';
//                 break;
//             default:
//                 return;
//         }
//     }

//     if (country === null) {
//         return;
//     }

//     const logo = document.querySelector('.headerlayout_logo>a>img');
//     if (logo) {
//         logo.src = `https://www.dpj.se/themes/dpj/assets/img/30yrs/${country}.png`;
//         logo.alt = alt;
//     }
// }

console.debug("custom.js: loaded"); 